/**
 * Created by andrey on 11.09.2025
 */

const LabSysTechSocial = function () {
    Social.call(this, connector.LABSYSTECH);
};

LabSysTechSocial.prototype = Object.create(Social.prototype);
LabSysTechSocial.prototype.constructor = LabSysTechSocial;

LabSysTechSocial.prototype._connect = function (callback) {
    connector.platform.callNative("Social.connect", (code, user) => {
        console.log(`Social.connect - ${code}`, user);

        this.user = user;

        callback(connector.STATUS_CONNECTED);
    });
};

LabSysTechSocial.prototype.isLoggedIn = function () {
    return Boolean(this.user && this.user.id);
};

LabSysTechSocial.prototype._getUserID = function () {
    return this.user && this.user.id;
};

LabSysTechSocial.prototype.getAccessToken = function () {
    return this.user && this.user.accessToken || "";
};

LabSysTechSocial.prototype._login = function (callback) {
    connector.platform.callNative("Social.login", (code, user) => {
        console.log(`Social.login - ${code}`, user);

        this.user = user;

        callback();
    });
};

LabSysTechSocial.prototype._aboutMe = function (callback) {
    connector.platform.callNative("Social.aboutMe", (code, response) => {
        callback(code, response);
    });
};

LabSysTechSocial.isAvailable = function () {
    return connector.platform.oneOf(connector.LABSYSTECH);
};
